
import TransMap from '@/components/TransMap'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
name: 'Order',
components: {
Cell,
Group,
TransMap
},
data () {
return {
ID: '',
logList: [],
order: {},
mapParams: null
}
},
created () {
this.ID = this.$route.query.ID || ''
this.loadData()
},
methods: {
renderMap () {
this.mapParams = {
TYPE: 0,
STATUS: this.order.STATUS,
TRANS_ID: this.ID,
CODE_102: this.order.CAR_GP, // 送货仓库
CODE_103: this.order.THCK 
}
},
loadData () {
let _this = this
_this.$vux.loading.show()
let url = 'TH.ashx?action=Form_Load'
this.$post(url, {
ID: this.ID
}).then(
response => {
_this.order = response
_this.$vux.loading.hide()
_this.loadLog()
_this.renderMap()
}
).catch(
response => {
console.log(response, '请求失败')
}
)
},
loadLog () {
let _this = this
let url = 'Trans_Log.ashx?action=Form_Query'
this.$post(url, {


WORKNO: _this.order.WORKNO
}).then(
response => {
response.forEach(item => {
if (item.STATUS_NAME == '提货中' && item.EVT_DATE < _this.order.DTR_TH) {
let yc = '2小时21分'
item.MORE_TEXT = '延迟：' + yc + '<br />最早起运时间:' + _this.order.DTR_TH
item.timeout = true
} else { item.timeout = false }
})
_this.logList = response


}
).catch(
response => {
console.log(response, '请求失败')
}
)
}
}

}



// WEBPACK FOOTER //
// ./src/pages/ctd/th/Trans.vue